import React from 'react';
import { SubtitleType } from '../../../models/ContentManagementInterface';
import InlineText from './InlineText';
import { webSubtitleSx } from './webTextStyles';

interface SubtitleBlockEditorProps {
  block: SubtitleType;
  onChange: (props: SubtitleType['properties']) => void;
}

/** A single heading edited in place — no body, tag, paste or footnotes. */
export default function SubtitleBlockEditor({ block, onChange }: SubtitleBlockEditorProps) {
  const { heading } = block.properties;
  return (
    <InlineText
      value={heading?.content ?? ''}
      unset={!heading?.content?.trim()}
      onChange={(value) => onChange({ heading: { ...heading, content: value } })}
      placeholder="Add a subtitle"
      ariaLabel="Subtitle"
      sx={webSubtitleSx}
    />
  );
}
